import { TextFieldHelper } from "@goodgamestudios/core";
import { Poker2Model } from "../../model/Poker2Model";
import { Poker2Dialog } from "./Poker2Dialog";

import Container = createjs.Container;
import MouseEvent = createjs.MouseEvent;

export class Poker2TutorialNoCancelDialog extends Poker2Dialog {
    public static NAME: string = "Poker2TutorialNoCancelDialog";

    constructor(disp: Container) {
        super(disp);
    }

    protected init(): void {
        super.init();
        this.tutorialNoCancelDialog.btn_yes.label = Poker2Model.languageData.getTextById("generic_btn_yes");
        this.tutorialNoCancelDialog.btn_no.label = Poker2Model.languageData.getTextById("generic_btn_no");
        TextFieldHelper.changeTextFromatSizeByTextWidth(14, this.tutorialNoCancelDialog.txt_title, Poker2Model.languageData.getTextById("tut_cancel_title"));
    }

    protected applyProperties(): void {
        this.tutorialNoCancelDialog.txt_title.mouseEnabled = false;
        this.tutorialNoCancelDialog.txt_copy.mouseEnabled = false;
        this.tutorialNoCancelDialog.mc_image.mouseEnabled = false;

        if (Poker2Model.userData.tutorialDone) {
            // a) ist first visit
            this.tutorialNoCancelDialog.txt_copy.text = Poker2Model.languageData.getTextById("tut_cancel_copy_rewardAlreadyReceived");
            this.tutorialNoCancelDialog.mc_image.visible = false;
        }
        else {
            // b) then user repeat this tutorial
            this.tutorialNoCancelDialog.txt_copy.text = Poker2Model.languageData.getTextById("tut_cancel_copy_rewardNotReceived");
            this.tutorialNoCancelDialog.mc_image.visible = true;
        }
    }

    protected onClick(event: MouseEvent): void {
        if (event.target instanceof BasicButton && !event.target.enabled)
            return;
        super.onClick(event);

        switch (event.target) {
            case this.tutorialNoCancelDialog.btn_yes:
                this.tutorialController.cancelTutorial();
                this.hide();
                break;
            case this.tutorialNoCancelDialog.btn_close:
            case this.tutorialNoCancelDialog.btn_no:
                this.layoutManager.tutPanel.show();
                this.layoutManager.tutPanel.showEnabledSpotlight();
                this.hide();
                break;
        }
    }

    //
    // getter & setter
    //

    protected get tutorialNoCancelDialog(): Library.PokerTutorial.PokerTutorialNoCancel {
        return this.disp as Library.PokerTutorial.PokerTutorialNoCancel;
    }
}

import { BasicButton } from "@goodgamestudios/poker2-createjs-assets";
